<template>
  <router-view></router-view>
</template>

<script>
export default {
  name:  'exhibition-control-certificate',
  data() {
    return {
    }
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 资质证书";
  }
}
</script>

<style scoped lang="scss">
</style>
